import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallbackurlComponent } from './callbackurl/callbackurl.component';
import { CompletionReportComponent } from './completion-report/completion-report.component';
import { DetailsComponent } from './details/details.component';
import { QuotaComponent } from './quota/quota.component';
import { SurveyListComponent } from './survey-list/survey-list.component';
import { TargetGroupComponent } from './target-group/target-group.component';
import { UploadRejectionsComponent } from './upload-rejections/upload-rejections.component';
const routes: Routes = [
  {path:"" , component:SurveyListComponent},
  {path:"survey-list" , component:SurveyListComponent},
  {path:"details/:survey_id" , component:DetailsComponent},
  {path:"quota/:survey_id" , component:QuotaComponent},
  {path:"callbackurl" , component:CallbackurlComponent},
  {path:'target-group/:survey_id',component:TargetGroupComponent},
  {path:'operations',component:UploadRejectionsComponent},
  {path:'operations/:survey_id',component:UploadRejectionsComponent},
  {path:'completion-report',component:CompletionReportComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SurveyRoutingModule { }
